module.exports = __webpack_public_path__ + "static/media/53_public_block_link.df484f43.png";